// Scoring helpers for the phrase guessing game.
// No penalty for wrong letters per user's spec.

export const DIFFICULTY_CONFIG = {
  easy: { base: 1000, perLetter: 10, label: "Easy" },
  normal: { base: 1500, perLetter: 15, label: "Normal" },
  hard: { base: 2000, perLetter: 25, label: "Hard" },
};

export const UNDER_MINUTE_BONUS = 500;
export const TIME_PENALTY_PER_SECOND = 5;

export const computeFinalScore = ({ difficulty, correctLetters, seconds }) => {
  const cfg = DIFFICULTY_CONFIG[difficulty] || DIFFICULTY_CONFIG.easy;
  const base = cfg.base;
  const letters = correctLetters * cfg.perLetter;
  const timePenalty = seconds * TIME_PENALTY_PER_SECOND;
  const underMinute = seconds < 60;
  const bonus = underMinute ? UNDER_MINUTE_BONUS : 0;
  const total = Math.max(0, base + letters - timePenalty + bonus);
  return { total, base, letters, timePenalty, bonus, underMinute };
};

export const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");
  return `${m}:${s}`;
};

// Fisher-Yates shuffle
export const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};
